import { BadgeVariant } from "../components/wombat-ui/components/Badge";
import { GroupType, SkillKind } from "../graphql/types";

export function getGroupColor(type: GroupType): BadgeVariant {
  switch (type) {
    case "Group::Partner":
      return "success";
    case "Group::Subsidiary":
      return "warning";
    case "Group::Team":
      return "help";
    case "Group::TrainingCourse":
      return "danger";
    default:
      return "primary";
  }
}

export function getSkillsColor(kind: SkillKind): BadgeVariant {
  switch (kind) {
    case "hard":
      return "primary";
    case "soft":
      return "help";
    case "tools":
      return "warning";
    case "language":
      return "success";
    default:
      return "primary";
  }
}
